import { Button, Nf, NumbersHelper, Tag, onLangChange } from '@hub/shared'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'

import './card-nf-data.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  nfData: Nf
  transactionState: string
  onChange?: (isReplaceInvoice: any) => void
}

export default ({ nfData, transactionState, onChange }: Props) => {
  const { t, i18n } = useTranslation('cardNfData')
  const numbersHelper = useMemo(() => new NumbersHelper(), [])
  const statusNf = useMemo(() => (nfData?.urlStorage ? 'alreadySend' : null), [nfData])
  const onLangChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [lang, setLang] = useState<string>('en')

  const statusNfObject = useMemo(
    () => ({
      alreadySend: {
        icon: 'fa-solid fa-circle-check',
        colorIcon: 'var(--green)',
        label: t('documentSent'),
      },
    }),
    [t]
  )

  const handleChange = () => {
    if (onChange && typeof onChange === 'function') {
      onChange(true)
    }
  }

  const formatDate = (date: string) => {
    return new Date(`${date?.split('T')[0]}T00:00:00-03:00`).toLocaleDateString(lang)
  }

  useEffect(() => {
    onLangChangeSubscription.current = onLangChange.subscribe((lang) => {
      setLang(lang)
    })
    return () => {
      onLangChangeSubscription.current?.unsubscribe()
    }
  })

  return (
    <section
      className={'card-nf-data display-flex-column justify-content-space-between'}
      style={{ border: '1px solid var(--border_color)' }}
    >
      <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div className="display-flex align-items-center">
          <i className="fa-regular fa-arrow-up-right-from-square mr-3" style={{ fontSize: '32px', color: 'var(--text_color)' }}></i>
          <div>
            <h6 className="m-0">{t('data')}</h6>
            <p data-testid="emissionDate">
              {t('emissionDate')} {formatDate(nfData?.emissionDate)}
            </p>
            <p data-testid="nfValue">
              {t('nfValue')} {numbersHelper.convertMoneyValue(nfData?.value, i18n.language)}
            </p>
            <p data-testid="nfNumber">
              {t('nfNumber')} {nfData?.serialnumber}
            </p>
          </div>
        </div>
        <div className="display-flex justify-content-center" style={{ gap: '1rem' }}>
          <a href={nfData?.urlStorage} target="_blank" className="view-nf button button-primary small" id="view-nf">
            {t('viewNf')}
            <i className="fa-regular fa-arrow-up-right-from-square ml-2"></i>
          </a>
          <Button
            onClick={() => handleChange()}
            className="replace-nf"
            id="replace-nf"
            color="transparent"
            borderColor="var(--primary_color)"
            textColor="var(--primary_color)"
            disabled={!['pending', 'review'].includes(transactionState)}
            inverted
          >
            {t('replaceNf')}
          </Button>
        </div>
      </div>
      {statusNf && (
        <Tag
          labels={[
            <i className={statusNfObject?.[statusNf]?.icon} style={{ color: `${statusNfObject?.[statusNf]?.colorIcon}` }}></i>,
            <span>
              {t('status')} <strong>{statusNfObject?.[statusNf]?.label}</strong>
            </span>,
          ]}
          style={{ width: '100%', border: 'none', backgroundColor: 'var(--background)' }}
        />
      )}
    </section>
  )
}
